@switch (variant()) {
  @case ('icon-button') {
    <button
      cdkMonitorElementFocus
      [disabled]="disabled()"
      type="button"
      class="if-button if-icon-button"
      [class.if-icon-button-sm]="size() === 'sm'"
      [class.if-icon-button-success]="iconButtonType() === 'success'"
      [class.if-icon-button-error]="iconButtonType() === 'error'"
      [class.if-icon-button-warning]="iconButtonType() === 'warning'"
      [class.if-icon-button-info]="iconButtonType() === 'info'"
      [class.if-icon-button-active]="active()">
      <ng-container *ngTemplateOutlet="projected" />
    </button>
  }
  @case ('header-notification') {
    <button
      cdkMonitorElementFocus
      [disabled]="disabled()"
      type="button"
      class="if-button if-header-notification"
      [class.if-header-notification-active]="active()">
      <ng-container *ngTemplateOutlet="projected" />
    </button>
  }
  @case ('header-avatar') {
    <button
      cdkMonitorElementFocus
      [disabled]="disabled()"
      type="button"
      class="if-button if-header-avatar"
      [class.if-header-avatar-active]="active()">
      <ng-container *ngTemplateOutlet="projected" />
    </button>
  }
  @case ('header-mobile-toggle') {
    <button
      cdkMonitorElementFocus
      [disabled]="disabled()"
      type="button"
      class="if-button if-header-mobile-toggle"
      [class.active]="active()">
      <ng-container *ngTemplateOutlet="projected" />
    </button>
  }
  @case ('sidenav-toggle') {
    <button
      cdkMonitorElementFocus
      [disabled]="disabled()"
      type="button"
      class="if-button if-sidenav-toggle"
      [class.active]="active()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
      </svg>
    </button>
  }
  @default {
    <button
      cdkMonitorElementFocus
      [disabled]="disabled()"
      type="button"
      class="if-button"
      [class.if-black]="variant() === 'black'"
      [class.if-ghost]="variant() === 'ghost'"
      [class.if-ghost-success]="variant() === 'ghost' && ghostType() === 'success'"
      [class.if-ghost-error]="variant() === 'ghost' && ghostType() === 'error'"
      [class.if-outline]="variant() === 'outline'"
      [class.if-link]="variant() === 'link'"
      [class.if-link-danger]="variant() === 'link-danger'"
      [class.if-xs]="size() === 'xs'"
      [class.if-sm]="size() === 'sm'"
      [class.if-input-sm]="size() === 'input-sm'"
      [class.if-input-inline]="size() === 'input-inline'"
      [class.if-lg]="size() === 'lg'"
      [class.if-icon]="size() === 'icon'"
      [class.if-error]="variant() === 'error'"
      [class.active]="active()"
      [class.if-flex]="flex()">
      <ng-container *ngTemplateOutlet="projected" />
    </button>
  }
}

<ng-template #projected>
  <ng-content />
</ng-template>
